const MAX_PERCENT = 100;

const USAGE_MEDIUM_THRESHOLD = 50;
const USAGE_HIGH_THRESHOLD = 80;
const PROGRESS_COLOR_LOW = 'var(--bui-fg-positive)';
const PROGRESS_COLOR_MEDIUM = 'var(--bui-fg-warning)';
const PROGRESS_COLOR_HIGH = 'var(--bui-fg-negative)';

export const getProgressColor = (percentUsed: number): string => {
  if (percentUsed >= USAGE_HIGH_THRESHOLD) {
    return PROGRESS_COLOR_HIGH;
  }
  if (percentUsed >= USAGE_MEDIUM_THRESHOLD) {
    return PROGRESS_COLOR_MEDIUM;
  }
  return PROGRESS_COLOR_LOW;
};

type CopilotBudgetProgressProps = {
  value: number;
};

export const CopilotBudgetProgress = ({
  value,
}: CopilotBudgetProgressProps) => {
  const clampedValue = Math.min(MAX_PERCENT, Math.max(0, value));

  return (
    <div
      aria-hidden="true"
      style={{
        display: 'flex',
        height: '8px',
        width: '100%',
        minWidth: '80px',
        borderRadius: 'var(--bui-radius-2)',
        overflow: 'hidden',
        backgroundColor: 'var(--bui-bg-neutral-2)',
      }}
    >
      <div
        style={{
          width: `${clampedValue}%`,
          backgroundColor: getProgressColor(clampedValue),
        }}
      />
      <div
        style={{
          width: `${MAX_PERCENT - clampedValue}%`,
          backgroundColor: 'var(--bui-bg-neutral-2)',
        }}
      />
    </div>
  );
};
